module.exports = __webpack_public_path__ + "img/nerdpress.d0f8147e.png";